import { render, staticRenderFns } from "./TrainingGroup.vue?vue&type=template&id=4b4282f2&scoped=true&"
import script from "./TrainingGroup.vue?vue&type=script&lang=js&"
export * from "./TrainingGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4282f2",
  null
  
)

export default component.exports